import { create } from 'zustand'

export type TankInfo = {
  size: number
  location: string
  tankName: string
  maxDensity: number
}

export type TankState = { [tankId: string]: TankInfo }

type TankStore = {
  tanks: TankState
  setTanks: (tanks: TankState) => void
}

export const useTankStore = create<TankStore>((set) => ({
  tanks: {},
  setTanks: (tanks) => {
    set(() => ({ tanks }))
  },
}))
